module.exports = __webpack_public_path__ + "img/thumb.0c5dfa41.jpeg";